export const contactsData = {
    email: 'altafrajatit@gmail.com',
    phone: '+91 9122538646',
    address: 'Ashoka Garden, Bhopal, Madhya Pradesh - 462023 ',

    sheetAPI: ''
}